import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { ChapterLabel } from "@/components/ChapterLabel";
import { CARLOS_PHOTO_URL, CREATOR_NAME } from "@/config";

export const Creador = () => {
  const photoRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: photoRef,
    offset: ["start end", "end start"],
  });
  const photoY = useTransform(scrollYProgress, [0, 1], [36, -36]);

  return (
    <section id="sobre-mi" className="bg-[#0B1120] px-5 py-24 md:py-32">
      <div className="mx-auto grid max-w-[1100px] grid-cols-1 items-center gap-12 lg:grid-cols-5 lg:gap-16">
        <Reveal className="lg:col-span-2">
          <motion.div
            ref={photoRef}
            style={{ y: photoY }}
            className="relative mx-auto max-w-sm"
          >
            <div className="absolute -inset-3 rounded-[2rem] border border-[#8B7CF6]/20" />
            <img
              data-testid="creador-photo"
              src={CARLOS_PHOTO_URL}
              alt={`${CREATOR_NAME}, fundador de la comunidad`}
              className="relative aspect-[4/5] w-full rounded-[1.75rem] object-cover shadow-[0_16px_60px_rgba(0,0,0,0.45)]"
              loading="lazy"
              decoding="async"
              width="800"
              height="1056"
            />
            <div className="absolute -bottom-5 left-1/2 w-max -translate-x-1/2 rounded-xl border border-[#22304D] bg-[#131D33] px-5 py-3 text-center shadow-[0_4px_20px_rgba(0,0,0,0.35)]">
              <p className="font-[Fraunces] text-sm font-semibold text-[#F5F1EA]">
                {CREATOR_NAME}
              </p>
              <p className="text-xs text-[#9AA6BE]">Fundador de la comunidad</p>
            </div>
          </motion.div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-3">
          <ChapterLabel number="08" testId="chapter-creador" />
          <h2 className="text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
            Creada desde la experiencia, no desde la teoría.
          </h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-[#9AA6BE] md:text-lg">
            <p>
              Sé lo que es tener una mente que no se detiene y sentir que muchas
              de las cosas que piensas no tienen espacio en las conversaciones
              habituales. También sé lo que supone sentirse diferente incluso
              estando acompañado.
            </p>
            <p className="font-medium text-[#E8E4DC]">
              Por eso he creado esta comunidad y este coaching: para reunir a
              personas con altas capacidades que
              necesitan un lugar donde poder expresarse, conectar y dejar de
              vivirlo todo únicamente dentro de su propia cabeza.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
